module.exports = __webpack_public_path__ + "img/tc.2272cf18.svg";